<template>
  <svg
    id="SVGRoot"
    width="60.0px"
    height="60.0px"
    viewBox="0 0 60.0 60.0"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg"
  >
    <defs id="defs6935" />
    <g id="layer1">
      <g
        id="window_open"
        class="outline"
        transform="matrix(0.9818551,0,0,1.0003094,0.51255609,0.1757888)"
      >
        <g
          id="g620"
          class="glass"
          transform="translate(-3.5065256e-4,2.0445674e-4)"
        >
          <path
            id="rect7103"
            d="M 4.7993293,41.099716 23.298566,38.830942 V 23.734867 H 4.7993293 Z m 9e-7,-18.673755 H 23.298567 L 23.385828,7.2426252 4.7993302,5.0611115 Z"
            class="UnoptimicedTransforms"
            transform="matrix(0.75594144,0,0,1.0756802,8.7249813,4.539309)"
          />
          <path
            id="rect7103-0"
            d="M 4.7993293,41.099716 23.298566,38.830942 V 23.734867 H 4.7993293 Z m 9e-7,-18.673755 H 23.298567 L 23.385828,7.2426252 4.7993302,5.0611115 Z"
            class="UnoptimicedTransforms"
            transform="matrix(-0.75594144,0,0,1.0756802,51.133481,4.5450246)"
          />
        </g>
        <path
          id="rect7103-11"
          d="M 3.5776825,4.0139852 24.258433,6.6318016 V 39.965332 L 3.5776825,42.321366 Z M 4.7993293,41.099716 23.298566,38.830942 V 23.734867 H 4.7993293 Z m 9e-7,-18.673755 H 23.298567 L 23.385828,7.2426252 4.7993302,5.0611115 Z"
          class="UnoptimicedTransforms"
          transform="matrix(0.75594144,0,0,1.0756802,8.7249813,4.539309)"
        />
        <path
          id="rect7103-0-3"
          d="M 3.5776825,4.0139852 24.258433,6.6318016 V 39.965332 L 3.5776825,42.321366 Z M 4.7993293,41.099716 23.298566,38.830942 V 23.734867 H 4.7993293 Z m 9e-7,-18.673755 H 23.298567 L 23.385828,7.2426252 4.7993302,5.0611115 Z"
          class="UnoptimicedTransforms"
          transform="matrix(-0.75594144,0,0,1.0756802,51.133481,4.5450246)"
        />
      </g>
      <g
        id="window_closed"
        class="outline"
        transform="matrix(0.97991595,0,0,1.014914,-55.240793,0.64411426)"
      >
        <g
          id="g624-8"
          class="glass"
          transform="translate(-5.6127263e-5,3.6528218e-4)"
        >
          <path
            id="rect7103-2-6"
            d="M 4.7993293,41.099716 H 23.298566 V 23.734867 H 4.7993293 Z m 9e-7,-18.673755 H 23.298567 V 5.0611115 H 4.7993302 Z"
            class="UnoptimicedTransforms"
            transform="matrix(0.84670015,0,0,1.0818368,65.416564,3.381713)"
          />
          <path
            id="rect7103-1-0"
            d="M 4.7993293,41.099716 H 23.298566 V 23.734867 H 4.7993293 Z m 9e-7,-18.673755 H 23.298567 V 5.0611115 H 4.7993302 Z"
            class="UnoptimicedTransforms"
            transform="matrix(0.84670015,0,0,1.0818368,84.461864,3.375412)"
          />
        </g>
        <path
          id="rect7103-2"
          d="M 3.5776825,4.0139852 H 24.607475 V 42.321366 H 3.5776825 Z M 4.7993293,41.099716 H 23.298566 V 23.734867 H 4.7993293 Z m 9e-7,-18.673755 H 23.298567 V 5.0611115 H 4.7993302 Z"
          class="UnoptimicedTransforms"
          transform="matrix(0.84670015,0,0,1.0818368,65.416564,3.381713)"
        />
        <path
          id="rect7103-1"
          d="M 3.5776825,4.0139852 H 24.607475 V 42.321366 H 3.5776825 Z M 4.7993293,41.099716 H 23.298566 V 23.734867 H 4.7993293 Z m 9e-7,-18.673755 H 23.298567 V 5.0611115 H 4.7993302 Z"
          class="UnoptimicedTransforms"
          transform="matrix(0.84670015,0,0,1.0818368,84.461864,3.375412)"
        />
      </g>
      <path
        id="rect7209"
        class="outline"
        d="M 8.078125,4.5390625 V 6.0664062 54.5 H 51.726562 V 4.5390625 Z m 3.056641,3.0566406 H 48.669922 V 51.441406 H 11.134766 Z"
      />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
.outline {
  stroke: $primary-color;
  fill: $primary-color;
}
.glass {
  stroke: $primary-color;
  stroke-width: 3;
  fill: $secondary-color;
  fill-opacity: 10%;
}
svg {
  #window_closed {
    transition: all 150ms linear;
  }
  #window_open {
    opacity: 0;
    transition: all 200ms linear;
  }
}
svg:hover {
  #window_closed {
    opacity: 0;
  }
  #window_open {
    opacity: 100;
  }
}
</style>
